var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103.71 18.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.25,
    y1: 17.18,
    x2: 22.76,
    y2: 2.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65f4cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4799e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,7.25a3.56,3.56,0,0,0-3.28-3.43H16.88V0H9.1V3.82H0V18.46H4.2a3.18,3.18,0,0,0,3.45-3.17v-.66h5.81a3.32,3.32,0,0,0,3.42-3,1,1,0,0,0,0-.25V4.61h1.45v6.72a3.43,3.43,0,0,0,3.61,3.3h4V7.25ZM7.65,4.61H9.1v9.23H7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34,6.29A2.72,2.72,0,0,1,35,8.46,2.78,2.78,0,0,1,34,10.64a3.51,3.51,0,0,1-2.41.83H30v3.28h-1.9V5.46h3.49A3.51,3.51,0,0,1,34,6.29Zm-4,.85V9.81h1.59a1.38,1.38,0,0,0,1-.37,1.33,1.33,0,0,0,.38-1,1.27,1.27,0,0,0-.39-1,1.41,1.41,0,0,0-1-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.63,7.78V9.46h-.51a2,2,0,0,0-1.37.46,1.76,1.76,0,0,0-.5,1.36v3.47h-1.9v-7h1.74v.85A2.31,2.31,0,0,1,40,7.7,2.33,2.33,0,0,1,40.63,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.65,8.68a3.44,3.44,0,0,1,1.1,2.58,3.45,3.45,0,0,1-1.1,2.59,3.86,3.86,0,0,1-5.3,0,3.49,3.49,0,0,1-1.08-2.6,3.47,3.47,0,0,1,1.09-2.58,3.86,3.86,0,0,1,5.29,0ZM43.71,9.9a1.93,1.93,0,0,0-.51,1.38,1.86,1.86,0,0,0,.51,1.35,1.7,1.7,0,0,0,1.3.53,1.72,1.72,0,0,0,1.28-.53,1.86,1.86,0,0,0,.52-1.35,1.9,1.9,0,0,0-.52-1.37A1.67,1.67,0,0,0,45,9.36,1.7,1.7,0,0,0,43.71,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.37,8.09a3.29,3.29,0,0,1,1.22,1.26l-1.32,1a2,2,0,0,0-1.68-1,1.73,1.73,0,0,0-1.31.54,1.88,1.88,0,0,0-.52,1.36,1.87,1.87,0,0,0,.52,1.37,1.7,1.7,0,0,0,1.31.55,2,2,0,0,0,1.68-1l1.32,1a3.34,3.34,0,0,1-1.23,1.27,3.44,3.44,0,0,1-1.8.46,3.64,3.64,0,0,1-2.64-1.05,3.53,3.53,0,0,1-1.09-2.61,3.47,3.47,0,0,1,1.09-2.58,3.64,3.64,0,0,1,2.64-1A3.46,3.46,0,0,1,55.37,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.26,11.91H59.37a1.77,1.77,0,0,0,.69,1,2.17,2.17,0,0,0,1.28.36,3.19,3.19,0,0,0,1.94-.7l.79,1.29a4.21,4.21,0,0,1-2.79,1,3.76,3.76,0,0,1-2.73-1.05,3.47,3.47,0,0,1-1.09-2.59,3.6,3.6,0,0,1,3.65-3.65,3.15,3.15,0,0,1,3.28,3.24A4.23,4.23,0,0,1,64.26,11.91ZM60,9.54a2,2,0,0,0-.61,1h3.18a1.36,1.36,0,0,0-.45-1A1.58,1.58,0,0,0,61,9.16,1.62,1.62,0,0,0,60,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.74,8.67l-1,1.17a2.23,2.23,0,0,0-1.56-.66c-.5,0-.75.16-.75.49a.42.42,0,0,0,.17.33,1.82,1.82,0,0,0,.57.29l.67.28a4.56,4.56,0,0,1,1.49.88,1.71,1.71,0,0,1,.47,1.25,2,2,0,0,1-.77,1.63,3.06,3.06,0,0,1-1.95.59,3.4,3.4,0,0,1-2.88-1.35l1-1.15a2.72,2.72,0,0,0,2,.94,1.22,1.22,0,0,0,.63-.15.47.47,0,0,0,.26-.43.4.4,0,0,0-.17-.34,2.6,2.6,0,0,0-.55-.29l-.75-.31A4.28,4.28,0,0,1,66.14,11a1.74,1.74,0,0,1-.47-1.26,1.86,1.86,0,0,1,.71-1.54,2.93,2.93,0,0,1,1.85-.55A3.2,3.2,0,0,1,70.74,8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.15,8.67l-1,1.17a2.23,2.23,0,0,0-1.56-.66c-.5,0-.75.16-.75.49A.41.41,0,0,0,74,10a2.09,2.09,0,0,0,.57.29l.68.28a4.5,4.5,0,0,1,1.48.88,1.67,1.67,0,0,1,.47,1.25,1.94,1.94,0,0,1-.76,1.63,3.06,3.06,0,0,1-2,.59,3.43,3.43,0,0,1-2.89-1.35l1-1.15a2.7,2.7,0,0,0,2,.94,1.22,1.22,0,0,0,.63-.15.47.47,0,0,0,.25-.43.39.39,0,0,0-.16-.34,2.74,2.74,0,0,0-.56-.29L74,11.84A4.18,4.18,0,0,1,72.55,11a1.7,1.7,0,0,1-.47-1.26,1.84,1.84,0,0,1,.71-1.54,2.91,2.91,0,0,1,1.85-.55A3.22,3.22,0,0,1,77.15,8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.42,14.75H85.33V10.28H80.12v4.47H79V5.46h1.1V9.29h5.21V5.46h1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.42,12a2.84,2.84,0,1,1-5.67,0V7.9h1.07v4.19a1.76,1.76,0,1,0,3.52,0V7.9h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.71,11.33a3.4,3.4,0,0,1-3.38,3.58,3.15,3.15,0,0,1-2.6-1.24v1.08h-1V4.19H97.8V8.9a3.16,3.16,0,0,1,2.52-1.16A3.42,3.42,0,0,1,103.71,11.33Zm-1.11,0a2.44,2.44,0,0,0-2.44-2.58,2.35,2.35,0,0,0-2.38,2.59,2.34,2.34,0,0,0,2.38,2.58A2.44,2.44,0,0,0,102.6,11.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.90f7b303eed257653b0cc6f4b6e6fff5.svg";
export { ForwardRef as ReactComponent };